import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Problem() {
  const painPoints = ['pidiendo delivery', 'haciendo siempre las mismas recetas', 'perdiendo tiempo pensando qué cocinar', 'dejando la Air Fryer guardada'];
  return <section className="py-20 md:py-32 bg-white relative" data-id="element-167">
      <div className="max-w-3xl mx-auto px-4" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-169">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal leading-tight mb-8" data-id="element-170">
            El verdadero problema no es tu Air Fryer
          </h2>

          <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed max-w-2xl mx-auto" data-id="element-171">
            <p data-id="element-172">
              Mucha gente cree que no usa la freidora porque no le gusta
              cocinar.
            </p>
            <p data-id="element-173">Pero la realidad es otra.</p>
            <p className="font-medium text-charcoal" data-id="element-174">
              Compraron una herramienta increíble... sin un sistema para usarla.
            </p>
            <p className="text-charcoal/60 text-base uppercase tracking-widest font-bold pt-4" data-id="element-175">
              Por eso terminan:
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream rounded-2xl p-8 md:p-10 border border-sand shadow-sm mb-12" data-id="element-176">
          <ul className="space-y-5" data-id="element-177">
            {painPoints.map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-178">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-0.5" data-id="element-179">
                  <X size={14} className="text-red-600 stroke-[3]" data-id="element-180" />
                </div>
                <span className="text-charcoal/80 font-medium" data-id="element-181">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-182">
          <div className="inline-block bg-white border border-sand px-8 py-6 rounded-xl shadow-sm text-lg text-charcoal/80 font-medium" data-id="element-183">
            <p className="mb-2 text-xl font-bold text-charcoal" data-id="element-184">
              AirPack resuelve eso.
            </p>
            <p data-id="element-185">No es un recetario.</p>
            <p data-id="element-186">
              Es un sistema completo para usar tu Air Fryer durante todo el año.
            </p>
          </div>
          <p className="text-2xl md:text-3xl font-serif italic text-ember mt-8" data-id="element-187">
            El problema nunca fue tu Air Fryer. Era no tener un sistema.
          </p>
        </motion.div>
      </div>
    </section>;
}